module.exports = __webpack_public_path__ + "img/Saudi-Arabia.890e07f0.jpg";